import { Box, Grid } from '@mui/material';
import { Field } from 'formik';
import MuiValidTextField from './input/MuiValidTextField';
import BusinessInfoAddress from 'src/components/BusinessInfoAddress';

const MovedInformation = () => {
  return (
    <Box
      id="moved-info"
      sx={{
        mt: { xs: '0.125rem', md: '0.5rem' },
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Date Business Moved"
            name="dateBusMoved"
            type="Date"
            variant="standard"
            InputLabelProps={{ shrink: true }}
            sx={{ width: '100%' }}
          />
        </Grid>
      </Grid>
      <div className="mt-4">
        <BusinessInfoAddress
          label="New Business Location"
          cityFieldName="busCity"
          zipFieldName="busZip"
          streetFieldName="busLoc"
        />
      </div>
    </Box>
  );
};

export default MovedInformation;
